import React from "react";

//UI Material
import { Chip } from "@mui/material";

export default function ContainedChip({ text, icon, color }) {
  return (
    <Chip
      label={text}
      color={color}
      icon={icon}
      sx={{
        marginTop: "2px",
        marginBottom: "2px",
        fontSize: "10px",
        maxWidth: "120px",
        height: "25px",
        fontWeight: "bold",
        color: "white",
      }}
    />
  );
}
